import React from "react";
import { createPortal } from "react-dom";
import { Box } from "@mui/material";

interface IRiskPageReportHtmlContainerProp {
    isPrinting: boolean;
    getContent: (isPrinting: boolean) => React.ReactNode;
}

export const RiskPageReportHtmlContainer = (props: IRiskPageReportHtmlContainerProp) => {
    return (<Box sx={{ padding: 2, height: "calc(100vh - 160px)", overflowY: "auto", overflowX: "hidden" }}>
        <>
            {props.getContent(false)}
            {props.isPrinting && createPortal(
                <div
                    id="riskPrint"
                    style={{
                        position: "absolute",
                        left: "-9999px",
                        top: "-9999px",
                        width: "1200px", // Mock desktop width so MUI grid/flex layouts compute correctly
                        zoom: 0.7
                    }}
                >
                    {props.getContent(true)}
                </div>,
                document.body
            )}
        </>
    </Box>);
};
